var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('UCFeatureList',{attrs:{"size":_vm.transformedSize,"items":_vm.transformedItems}})
}
var staticRenderFns = []

export { render, staticRenderFns }